<div class="orgApp-value-selector-container">
  <p class="orgApp-value-selector-label">{{ label | translate }}</p>
  <div class="orgApp-value-selector-grid">
    @for (value of values; track $index) {
    <button class="orgApp-value-selector-btn" mat-button [ngClass]="{ selected: isSelected(value) }"
      (click)="select(value)">
      {{ value }}
    </button>}
  </div>
</div>
